import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import ja from './ja'
import { LETTER_FORMAT } from '../utils/constants'
import { jsUcfirst, titleCase } from '../utils/utils'

Vue.use(VueI18n)

class CustomFormatter {
    constructor (options) {
      // ...
    } 
    interpolate (message, values) {
        var result = message
        if (values && values.format) {
            switch (values.format) {
                case LETTER_FORMAT.UPPERCASE:
                    result = result.toUpperCase()
                    break
                case LETTER_FORMAT.UPTITLECASE:
                    result = titleCase(result)
                    break
                case LETTER_FORMAT.UPFIRSTCASE:
                    result = jsUcfirst(result)
                    break
            }
            
        }
        return [result]
    }
}

const messages = {
    en: en,
    ja: ja
}

const i18n = new VueI18n({
    locale: 'ja',
    formatter: new CustomFormatter({}),
    messages
})

export default i18n